import { Item } from '../../api/CollectionsAPI';
import { isImageFile, isVideoFile } from '../../shared/fileUtils';
import { BolderText } from '../BolderText/BolderText';

type Props = {
  item: Item,
  actions?: JSX.Element
}

function MarketingCollectionItemElement({ item, actions }: Props) {
  const firstImage = item.media ? item.media.find(m => isImageFile(m)) : null;
  const fallbackMedia = item.media && item.media.length > 0 ? item.media[0] : null;
  const imageUrl = firstImage || fallbackMedia;
  const thumbnailUrl = imageUrl ? imageUrl.replace(/(\.[\w\d]+)$/, '-thumbnail$1') : undefined;
  const isVideo = imageUrl && isVideoFile(imageUrl);

  return (
    <div className="flex justify-between space-x-3 h-5">
      <div className="flex space-x-3 items-center">
        { imageUrl && (
          isVideo ? (
            <div className="w-8 h-8 flex items-center justify-center bg-black rounded text-white text-[8px]">
              VIDEO
            </div>
          ) : (
            <img 
              src={thumbnailUrl} 
              onError={(e) => e.currentTarget.src = imageUrl} 
              className="w-8 h-8 rounded" 
              alt="model" 
            />
          )
        )}
        <BolderText text={item.name} />
        { item.collectionName && <p>{ item.collectionName } </p>}
      </div>
      <span className="flex space-x-5">
        { actions }
      </span>
    </div>
  );
}

export default MarketingCollectionItemElement;
